import React from 'react';
import cn from 'classnames';
import Paper from '@material-ui/core/Paper';
import { Link } from 'react-router-dom';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import MenuIcon from '@material-ui/icons/Menu';

interface Props {
  className?: string;
  title: string;
  isMobile: boolean;
}

const Menubar: React.FC<Props> = React.memo(
  ({ className, title, isMobile }) => {
    return (
      <div className={cn(className, 'fixed z-10')}>
        {isMobile ? (
          <Paper className="w-full fixed h-16 flex text-3xl font-bold justify-between pt-3">
            <div>
              <PopupState variant="popover" popupId="demo-popup-menu">
                {(popupState) => (
                  <React.Fragment>
                    <MenuIcon
                      {...bindTrigger(popupState)}
                      className="mx-4 cursor-pointer">
                      Menu
                    </MenuIcon>
                    <Menu {...bindMenu(popupState)}>
                      <MenuItem onClick={popupState.close}>
                        <Link className="w-full" to="/chart/line">
                          CHART
                        </Link>
                      </MenuItem>
                      <MenuItem onClick={popupState.close}>
                        <Link className="w-full" to="/finance">
                          FINANCE
                        </Link>
                      </MenuItem>

                      <MenuItem onClick={popupState.close}>
                        <Link className="w-full" to="/ai">
                          AI
                        </Link>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          popupState.close();
                          window.alert('not launching');
                        }}>
                        <Link className="w-full" to="/report">
                          REPORT
                        </Link>
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          popupState.close();
                          window.alert('not launching');
                        }}>
                        <Link className="w-full" to="/my">
                          MY
                        </Link>
                      </MenuItem>
                    </Menu>
                  </React.Fragment>
                )}
              </PopupState>
              <Link to="/" className="text-4xl font-bold">
                {title}
              </Link>
            </div>
            <div className="mr-6 space-x-4 pt-1">
              <span>IC</span>
              <span>IC</span>
            </div>
          </Paper>
        ) : (
          <Paper className="w-full xl:px-44 lg:px-20 lg:h-16 px-10 fixed md:h-16 flex text-4xl font-bold justify-between  pt-3">
            <Link to="/" className="text-4xl font-bold">
              {title}
            </Link>
            <div className="font-bold space-x-10 text-xl pt-3 ">
              <Link className="hover:text-indigo-400" to="/chart/line">
                CHART
              </Link>
              <Link className="hover:text-indigo-400" to="/finance/news">
                FINANCE
              </Link>
              <Link className="hover:text-indigo-400" to="/ai">
                AI
              </Link>
              <Link className="hover:text-indigo-400" to="/report">
                REPORT
              </Link>
            </div>
            <div className="space-x-4">
              <span>IC</span>
              <span>IC</span>
            </div>
          </Paper>
        )}
      </div>
    );
  },
);

export default Menubar;
